module.exports = __webpack_public_path__ + "static/media/GPC_BigOne.94104596.png";